import React from "react";

const UnderConstruction = () => {
  return (
    <div className="under-construction">
      <div className="construction-icon">🚧</div>

      <h2>Under Construction</h2>

      <p>
        We're working on this page and it will be available soon.
      </p>
    </div>
  );
};

export default UnderConstruction;